import { render, staticRenderFns } from "./AddContentItemModal.vue?vue&type=template&id=163552c1&"
import script from "./AddContentItemModal.vue?vue&type=script&lang=js&"
export * from "./AddContentItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports